import Footer from "./Footer";
import Header from "./Header";
import ShlokCard from "./ShlokCard";
import ideals_json from "../data/ideals.json";
import parse from "html-react-parser";
import translatedHeading from "../utils/util";
import "../styles/App.css";


const Ideals = () => {
  const currentLanguageVal = localStorage.getItem("language");
  const currentLanguage = currentLanguageVal ? currentLanguageVal : "en";
  const ideals_data = ideals_json;
  return (
    <>
      <Header />
      <div className="page-header">{translatedHeading("Ideals")}</div>
      <div className="ideals">
        <div>
          {ideals_data.map((item, index) => {
            let tag = item.tag;
            let value =
              currentLanguage === "en" ? item.value : item["value-hindi"];
            if (tag === "ShlokCard") {
              return <ShlokCard key={index} shlok={value} />;
            } else if (tag === "p") {
              return <p key={index}>{parse(value)}</p>;
            } else if (tag === "div") {
              return (
                <div key={index} className={item.className}>
                  {value}
                </div>
              );
            }
          })}
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Ideals;
